import type { Command, FloatingToolbarItem } from '@atlaskit/editor-common/types';

export const separator = (hidden?: boolean): FloatingToolbarItem<Command> => {
	return {
		type: 'separator',
		hidden: hidden,
	};
};
